<div class="value" *ngIf="followers" [transValues]="{count: followers | number}" trans>:count Followers</div>
<span class="separator" *ngIf="followers && followed">-</span>
<div class="value" *ngIf="followed" [transValues]="{count: followed | number}" trans>:count Following</div>
